import { createContext } from 'react';
import { type MessageBundle } from '@amzn/arb-tools';

const ArbBundleContext = createContext<MessageBundle | undefined>(undefined);

export default ArbBundleContext;
